"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsEmptyState = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../../atoms");

require("./NotificationsEmptyState.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var HELP_CENTER_URL = "https://traceup.com/soccer/help";
var TRACE_ID_URL = "https://go.traceup.com/traceid";

var NotificationsEmptyState = function NotificationsEmptyState(_ref) {
  var welcomeMessage = _ref.welcomeMessage;

  var getTitle = function getTitle() {
    if (welcomeMessage) {
      return "Your updates will appear here.";
    } else {
      return "No new updates.";
    }
  };

  var getMessage = function getMessage() {
    if (welcomeMessage) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Welcome to the Trace update center. Find helpful tips and activity info here. Need help navigating Trace? Check out our\xA0", /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        tag: "a",
        href: HELP_CENTER_URL
      }, "help center"), ".");
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Trace iD is the home for your soccer memories and highlights. Save moments to your\xA0", /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        tag: "a",
        href: TRACE_ID_URL
      }, "Trace iD"), " or find out more\xA0", /*#__PURE__*/_react.default.createElement(_atoms.Element, {
        tag: "a",
        href: HELP_CENTER_URL
      }, "here"), ".");
    }
  };

  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "EmptyState"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: getTitle(),
    color: _atoms.Color.Black,
    type: _atoms.Label.Type.Heading4,
    marginBottom: "2"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    content: getMessage(),
    color: _atoms.Color.Grey1,
    type: _atoms.Label.Type.Body
  }));
};

exports.NotificationsEmptyState = NotificationsEmptyState;